import { EsignModificationConstants } from 'constants/eSignContractModification';
import { createAction } from 'redux-actions';

export const fetchContractModificationAction = createAction(EsignModificationConstants.FETCH_CONTRACT_MODIFICATION);
export const fetchSettlementModificationAction = createAction(EsignModificationConstants.FETCH_SETTLEMENT_MODIFICATION);
export const fetchScraWaiverAction = createAction(EsignModificationConstants.FETCH_SCRA_WAIVER);
export const eSignContractModificationAgreementAction = createAction(EsignModificationConstants.ESIGN_CONTRACT_MODIFICATION);
export const eSignSettlementAgreementAction = createAction(EsignModificationConstants.ESIGN_SETTLEMENT_MODIFICATION);
export const eSignScraWaiverAction = createAction(EsignModificationConstants.ESIGN_SCRA_WAIVER);
